// libs
import get from 'lodash/get';

// defs
import { IWidgetTracking } from 'shared/components/AdPlatformWidgets/types';
import { ITrackingCommonFields } from './types';


let EVENTS: { [key: string]: IWidgetTracking } = {};
let COMMON: Pick<
  ITrackingCommonFields,
  'platform' | 'vertical' | 'app_version' | 'session_id' | 'source' | 'customer_id'
> = {
  platform: 'mweb',
  vertical: 'www.nykaafashion.com',
  app_version: '',
  session_id: '',
  source: 'nf-web',
  customer_id: '',
};

export const setCommonConfig = ({
  platform,
  source,
  vertical,
  customer_id,
}: Pick<ITrackingCommonFields, 'platform' | 'source' | 'vertical' | 'customer_id'>) => {
  COMMON = {
    ...COMMON,
    platform,
    source,
    vertical,
    customer_id,
  };
};

export const addEvents = (trackingData: Omit<IWidgetTracking, 'impressions' | 'timestamp'>) => {
  const transaction_id = get(trackingData, 'transaction_id', '');
  const currentTimestamp = new Date().getTime() / 1000;
  if (EVENTS[transaction_id] === undefined) {
    EVENTS[transaction_id] = {
      ...trackingData,
      impressions: 0,
      timestamp: currentTimestamp,
    };
  }
  const currentImpressions = EVENTS[transaction_id].impressions;
  EVENTS[transaction_id] = {
    ...EVENTS[transaction_id],
    impressions: currentImpressions + 1,
    timestamp: currentTimestamp,
  };
};



